//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RecurringAttendanceCreateMode } from './Enums';

export class CalendarBookingInputItem extends ItemBase {
    EventID: string | null = null;
    TeacherID: string | null = null;
    StartDate: string = "1970-01-01T00:00:00";
    AllDay: boolean = false;
    Duration: number = 0;
    EventCategoryID: string | null = null;
    EventLocationID: string | null = null;
    MakeUp: boolean = false;
    RecurringMode: RecurringAttendanceCreateMode = RecurringAttendanceCreateMode.None;

    constructor(initializer?: Partial<CalendarBookingInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarBookingInputItem";
}
